// extracted by mini-css-extract-plugin
export default {"container":"about_container__fKjIq","container_small":"about_container_small__NCb4p","container-lg":"about_container-lg__XdMgr","main":"about_main__jHipE"};